// 登录路由
export const onlypageRouter = [
  // 微信支付
  {
    path: "/weChatPay",
    name: "weChatPay",
    meta : { title: "GPUEZ智算云 - 微信支付" },
    component: resolve => require(["@/page/control/userPage/weChatPay/WeChatPay"], resolve),
  },
  
  // fasttarget
  {
    path: "/FastTarget",
    name: "FastTarget",
    meta : { title: "GPUEZ智算云 - 算力中心 - Target" },
    component: resolve => require(["@/page/control/slCenter/container/FastTarget"], resolve),
  },
  // 404 页面
  {
    path: "*",
    name: "404",
    meta : { title: "GPUEZ智算云 - 404" },
    component: resolve => require(["@/page/notFind404/notFind404"], resolve)
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/onlypageRouter.js